var _g, _g2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.038 0 40 8.962 40 20C40 31.038 31.038 40 20 40C8.962 40 0 31.038 0 20C0 8.962 8.962 0 20 0Z",
    fill: "#549C35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 2.44531C29.6886 2.44531 37.556 10.3127 37.556 20.0026C37.556 29.6925 29.6886 37.5599 19.9987 37.5599C10.3088 37.5599 2.44141 29.6925 2.44141 20.0026C2.44141 10.3127 10.3088 2.44531 19.9987 2.44531Z",
    fill: "#549C35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 5.80273C27.8373 5.80273 34.1996 12.165 34.1996 20.0011C34.1996 27.8373 27.8373 34.1996 20.0011 34.1996C12.165 34.1996 5.80273 27.8373 5.80273 20.0011C5.80273 12.165 12.165 5.80273 20.0011 5.80273Z",
    fill: "#549C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5751 21.799C14.2944 23.178 17.7331 25.936 17.7331 25.936C17.7331 25.936 24.0517 18.8929 27.211 15.3715",
    fill: "#549C35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5751 21.799C14.2944 23.178 17.7331 25.936 17.7331 25.936C17.7331 25.936 24.0517 18.8929 27.211 15.3715",
    stroke: "white",
    strokeWidth: 3.10542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifySuccess);
export default __webpack_public_path__ + "static/media/notify-success.b5d11d80.svg";
export { ForwardRef as ReactComponent };